import { render, staticRenderFns } from "./UserLoginRegExpSetupView.vue?vue&type=template&id=84148d30&scoped=true&"
import script from "./UserLoginRegExpSetupView.vue?vue&type=script&lang=ts&"
export * from "./UserLoginRegExpSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84148d30",
  null
  
)

export default component.exports